import { useStore } from 'effector-react'
import { useMemo } from 'react'
import { $currentStepFlags } from './stepModel'

export const useTitle = () => {
  const {
    isAdditionalDataStep,
    isPassportStep,
    isDriverLicenseStep,
    isConfirmCodeStep,
    isSuccessStep,
    isErrorStep,
    isCorrectionStep,
  } = useStore($currentStepFlags)

  const title = useMemo(() => {
    if (isPassportStep) return 'Паспорт'
    if (isDriverLicenseStep) return 'Водительские права'
    if (isAdditionalDataStep) return 'Дополнительные данные'
    if (isConfirmCodeStep) return 'Последний шаг!'
    if (isSuccessStep) return 'Регистрация завершена'
    if (isCorrectionStep) return 'Исправление данных'
    if (isErrorStep) return 'Ошибка регистрации'

    return 'Регистрация'
  }, [
    isAdditionalDataStep,
    isConfirmCodeStep,
    isDriverLicenseStep,
    isErrorStep,
    isPassportStep,
    isSuccessStep,
    isCorrectionStep,
  ])

  return title
}
